import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

import Email from '@material-ui/icons/Email'
import Phone from '@material-ui/icons/Phone'
import Public from '@material-ui/icons/Public'

const useStyles = makeStyles(theme => ({
    paper: {
        marginBottom: 20,
        padding: 10,
        minWidth: 240,
        boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.19)',
    },
    button: {
        margin: '0 5px',
    },    
    divider: {
        margin: '5px 0',
    },
}));

const sendMail = email => window.location = `mailto:${email}`
const makeCall = number => window.location = `tel:${number}`
const openPage = page => window.open(page, '_blank')

export default function LibraryDetails(props) {
    const classes = useStyles();

    const library = props.location.state.library

    return (
        <Grid container justify="center">
            <Grid item xs sm={6} md={4}>
                <Box m={1}>
                    <Paper className={classes.paper}>
                        <Typography variant="h5">{library.name}</Typography>
                        
                        <Typography variant="subtitle1">{library.initials}</Typography>

                        <Box fontWeight={500} pt={2}>
                            Telefone:&nbsp;
                            <Typography variant="body2" component="span">
                                {library.phone_number || "não informado"}
                            </Typography>
                        </Box>
                        <Box fontWeight={500}>
                            Email:&nbsp;
                            <Typography variant="body2" component="span">
                                {library.email || "não informado"}
                            </Typography>
                        </Box>
                        <Box fontWeight={500}>
                            Responsável:&nbsp;
                            <Typography variant="body2" component="span">
                                {library.librarian || "não informado"}
                            </Typography>
                        </Box>
                        <Divider className={classes.divider}></Divider>
                        <Box fontWeight={500}>
                            Endereço:&nbsp;
                            <Typography variant="body2">
                                {library.address}
                            </Typography>
                        </Box>
                        <Divider className={classes.divider}></Divider>
                        <Box fontWeight={500}>
                            Horário de funcionamento:&nbsp;
                            {library.opening_hours.split('\r\n').map((item, index) => 
                                (<Typography key={index} variant="body2">
                                    {item}
                                </Typography>)
                            )}
                        </Box>

                        <Box display="flex" justifyContent="space-between" mt={1}>
                            {library.website && 
                                <Box flexGrow={1} p={1}>
                                    <Button 
                                        color="primary" 
                                        variant="outlined" 
                                        fullWidth={true}
                                        onClick={() => openPage(library.website)}
                                    >
                                        <Public />
                                    </Button>
                                </Box>
                            }
                            {library.email && 
                                <Box flexGrow={1} p={1}>
                                    <Button 
                                        color="primary" 
                                        variant="outlined" 
                                        fullWidth={true}
                                        onClick={() => sendMail(library.email)}
                                    >
                                        <Email />
                                    </Button>
                                </Box>
                            }
                            {library.phone_number && 
                                <Box flexGrow={1} p={1}>
                                    <Button 
                                        color="primary" 
                                        variant="outlined" 
                                        fullWidth={true}
                                        onClick={() => makeCall(library.phone_number)}
                                    >
                                        <Phone />
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Paper>
                </Box>
            </Grid>
        </Grid>
    );
}